












































































































































































import { Component, Prop, Vue, Watch, } from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    Input,
    EmployerPhone,
    ErrorSummary
  }
})
export default class ServiceContacts extends Vue {
  $router: VueRouter;
  $validator: Validator;

  portalCustomizationStore = usePortalCustomizationStore();

  isSubmitting = false;

  isPrimaryContactServiceContact = false;
  primaryContactTitleOverride = "";
  primaryContactHoursConfig: "hide" | "default" | "custom" = "default";
  primaryContactCustomHours = "";
  secondaryContactPhone = "";
  secondaryContactShowPhone = false;
  secondaryContactEmail = "";
  secondaryContactTitle = "";
  secondaryContactHoursConfig: "hide" | "custom" = "hide";
  secondaryContactCustomHours = "";

  @Prop() partnerId: number;

  mounted () {
    this.onPartnerIdChanged(this.partnerId);
    this.initialize();
  }

  @Watch("partnerId")
  onPartnerIdChanged (partnerId) {
    this.portalCustomizationStore.getSupportInfo({ partnerId, employerId: 0 });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  @Watch("portalCustomizationStore.isSupportInfoLoaded")
  initialize () {
    if (this.portalCustomizationStore.isSupportInfoLoaded && !this.portalCustomizationStore.supportInfo.isFallbackData) {
      this.isPrimaryContactServiceContact = this.portalCustomizationStore.supportInfo.isPrimaryContactServiceContact;
      this.primaryContactTitleOverride = this.portalCustomizationStore.supportInfo.primaryContactTitleOverride;
      this.primaryContactHoursConfig = this.portalCustomizationStore.supportInfo.primaryContactHoursConfig;
      this.primaryContactCustomHours = this.portalCustomizationStore.supportInfo.primaryContactCustomHours;
      this.secondaryContactPhone = this.portalCustomizationStore.supportInfo.secondaryContactPhone;
      this.secondaryContactShowPhone = this.portalCustomizationStore.supportInfo.secondaryContactShowPhone;
      this.secondaryContactEmail = this.portalCustomizationStore.supportInfo.secondaryContactEmail;
      this.secondaryContactTitle = this.portalCustomizationStore.supportInfo.secondaryContactTitle;
      this.secondaryContactHoursConfig = this.portalCustomizationStore.supportInfo.secondaryContactHoursConfig;
      this.secondaryContactCustomHours = this.portalCustomizationStore.supportInfo.secondaryContactCustomHours;
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.portalCustomizationStore.savePartnerSupportInfo({
                partnerId: this.partnerId,
                supportInfo: {
                  ...this.portalCustomizationStore.supportInfo,
                  isPrimaryContactServiceContact: this.isPrimaryContactServiceContact,
                  primaryContactTitleOverride: this.primaryContactTitleOverride,
                  primaryContactHoursConfig: this.primaryContactHoursConfig,
                  primaryContactCustomHours: this.primaryContactCustomHours,
                  secondaryContactPhone: this.secondaryContactPhone,
                  secondaryContactShowPhone: this.secondaryContactShowPhone,
                  secondaryContactEmail: this.secondaryContactEmail,
                  secondaryContactTitle: this.secondaryContactTitle,
                  secondaryContactHoursConfig: this.secondaryContactHoursConfig,
                  secondaryContactCustomHours: this.secondaryContactCustomHours,
                }
              })
              .then(resp => {
                this.isSubmitting = false;
              });
        });
  }
}
